import axios from "axios";

const model = "CAProperties";

export default {
  details(id) {
    return axios.get(`/${model}/${id}/details`);
  },

  filter({ params }) {
    return axios.get(`/${model}/filter`, { params });
  },

  getCatalog({ params }) {
    return axios.get(`/${model}/catalog`, { params });
  },

  listing({ params }) {
    return axios.get(`/${model}/listing`, { params });
  },

  promoted() {
    return axios.get(`/${model}/promoted`);
  },

  updatePromoted(id, value) {
    return axios.put(`/${model}/${id}/promote`, { value });
  },

  updateAuction(id, value) {
    return axios.put(`/${model}/${id}/auctioned`, { value });
  }
};
